var map = {
	"./1.webp": 58495,
	"./10.webp": 49529,
	"./2.webp": 61342,
	"./3.webp": 22233,
	"./4.webp": 9440,
	"./5.webp": 96931,
	"./6.webp": 89506,
	"./7.webp": 36173,
	"./8.webp": 40356,
	"./9.webp": 4391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61060;